import { Component, Inject, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import { EmployeeHttpClient } from 'src/app/shared/flight-log-api/employees/employee-client.service';
import { FlightLogApiHttpClient } from 'src/app/shared/flight-log-api/flight-log-api.service';
import { flightOutcomeDisplay } from 'src/app/shared/flight-log-api/flights/flight-client.model';
import {
  aircraftTypeDisplay,
  flightStatusDisplay,
  flightTypeDisplay,
} from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { AircraftEntity } from 'src/store/aircraft/aircraft.model';
import { BaseEntity } from 'src/store/base/base.model';
import { FlightCadSummary } from 'src/store/flight-log/flight-log.model';
import { formatMomentDate } from 'src/util/dateLib';
import { filterNull } from 'src/util/rxjs/operators';
import { getOrElse, isNullOrWhitespace } from 'src/util/values';
import { FlightLogViewModel } from 'src/view-models/flight-log-view-model';
import { FlightLogFeatures, UserViewModel } from 'src/view-models/user-view-model';

@Component({
  selector: 'fl-view-flight-log-summary',
  templateUrl: './view-flight-log-summary.component.html',
  styleUrls: ['./view-flight-log-summary.component.scss'],
})
export class ViewFlightLogSummaryComponent implements OnInit {
  @Input()
  public flightSummary: FlightCadSummary;
  @Input()
  public flightLog: FlightLogViewModel;

  public updatedByEmployee$: Observable<string | undefined>;
  public base$: Observable<BaseEntity | undefined>;
  public aircraft$: Observable<AircraftEntity | undefined>;

  public get features(): FlightLogFeatures {
    return this.user.flightLogFeatures;
  }

  get flightTime() {
    return this.flightLog.entries[0] != null ? this.flightLog.entries[0].flightTime : null;
  }

  get dateOfService() {
    const effectiveDos =
      this.flightTime != null ? this.flightTime : this.flightSummary.dateOfService;

    return effectiveDos != null ? formatMomentDate(effectiveDos, 'MM/DD/YYYY') : null;
  }

  get aircraftType() {
    return aircraftTypeDisplay(
      getOrElse(this.flightSummary.aircraft, {} as AircraftEntity).aircraftType,
    );
  }

  get flightStatus() {
    return flightStatusDisplay(this.flightSummary.flightStatus);
  }

  get flightType() {
    if (this.flightLog.flightType != null) {
      return flightTypeDisplay(this.flightLog.flightType);
    }
  }

  get isSimple(): boolean {
    return this.flightLog.mode === 'Simple';
  }

  get flightOutcome() {
    return flightOutcomeDisplay(this.flightSummary.flightOutcome);
  }

  get isAviationSupervisor() {
    return this.user.isAviationSupervisor;
  }

  constructor(
    @Inject(USER) public user: UserViewModel,
    private _employees: EmployeeHttpClient,
    private _flightLogs: FlightLogApiHttpClient,
  ) {}

  public ngOnInit() {
    if (this.flightLog.updatedBy != null) {
      this.updatedByEmployee$ = isNullOrWhitespace(this.flightLog.updatedBy)
        ? of(undefined)
        : this._employees.getById(this.flightLog.updatedBy).pipe(
            filterNull(),
            map((e) => `${e.firstName} ${e.lastName} (${e.id})`),
          );
    }
    if (this.flightLog.aircraftId != null) {
      this.aircraft$ = this._flightLogs.aircraft.getById(this.flightLog.aircraftId).pipe(share());
    }
    if (this.flightLog.baseId != null) {
      this.base$ = this._flightLogs.bases.getById(this.flightLog.baseId).pipe(share());
    }
  }
}
